<template>
  <div class="input-root" :style="getRootStyle">
    <div class="form-label label-text" v-if="label">
      {{ $t(label) }}
      <span v-if="is_required" class="req-sign">*</span>
    </div>

    <div
      class="form-control disabled"
      :style="cus_style"
      v-if="disabled || readOnly"
    >
      {{ inputField || $t(placeholder) }}
    </div>
    <validation-provider v-else :name="name" :rules="rules" v-slot="{ errors }">
      <b-form-textarea
        :class="[
          'form-control',
          {
            'invalid-input':
              is_invalid || (errors && errors.length) ? true : false,
          },
        ]"
        :id="id"
        :type="type"
        :label="label"
        :disabled="disabled ? true : false"
        :placeholder="$t(placeholder)"
        v-model.trim="inputField"
        :style="cus_style"
        :readonly="readOnly"
        :ref="cus_ref"
        :rows="rows"
        :maxlength="maxLength"
        @keydown.enter="$emit('enter')"
      ></b-form-textarea>
      <div class="character-counter" v-if="showCharacterCount">
        {{ currentLength }}/{{ maxLength }}
      </div>
      <div class="helper-text" :style="helper_text_style" v-if="helper_text">
        {{ $t(helper_text) }}
      </div>
      <div
        class="error-text"
        :style="helper_text_style"
        v-if="errors && errors.length"
      >
        {{ errors[0] }}
      </div>
      <slot name="attachment"></slot>
    </validation-provider>
  </div>
</template>

<script>
export default {
  emits: ["change-value"],
  props: {
    id: [String, Number],
    type: String,
    label: String,
    placeholder: String,
    is_invalid: Boolean,
    helper_text: String,
    helper_text_style: String,
    field: String,
    value: String,
    cus_style: String,
    remove_default_margin: Boolean,
    readOnly: Boolean,
    disabled: Boolean,
    cus_ref: String,
    is_required: Boolean,
    rules: String,
    name: String,
    rows: {
      type: String,
      default: "3"
    },
    maxLength: {
      type: Number,
      default: 1000
    },
    showCharacterCount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { inputField: this.value };
  },
  watch: {
    value: function (val) {
      this.inputField = val;
    },
    inputField() {
      this.$emit("change-value", this.inputField, this.field);
      this.$emit("change");
    },
  },
  computed: {
    getRootStyle() {
      return `margin-bottom: ${
        this.remove_default_margin ? "0px" : "20px"
      };position:relative;`;
    },
    currentLength() {
      return this.inputField ? this.inputField?.length : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-size: 14px;
  color: var(--color-61);
  margin-bottom: 5px;
  font-weight: 700;
}

.invalid-input {
  border-color: var(--color-47) !important;
  background-color: var(--color-01) !important;
}

.character-counter {
  font-size: 12px;
  color: var(--color-132);
  text-align: end;
  margin-top: 5px;
  font-weight: 400;
}

.helper-text {
  font-size: 12px;
  color: var(--color-132);
  margin-top: 5px;
  font-weight: 400;
}

.form-control {
  width: 100%;
  font-size: 14px;
  padding: 20px 10px;
  background: var(--color-01);
  color: var(--color-61);
  border: 1px solid;
  border-radius: 6px;
  border-color: var(--color-64);
  box-shadow: 0px 1px 2px var(--color-37);
  font-weight: 400;

  &:focus-visible {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:hover {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:focus {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:disabled {
    background-color: var(--color-67);
  }
  &.disabled {
    overflow-wrap: break-word;
  }
}
</style>
